
<div *ngIf="bgSrcUrl!=undefined || bgSrcUrl!=null" class="full-page-background" [ngStyle]="{'background-image' : 'url('+bgSrcUrl+')'}"></div>

<div *ngIf="this.backgroundGradient!=undefined" class="full-page-background" [ngStyle]="{'background-image' : this.backgroundGradient}"></div>

